module.exports = __webpack_public_path__ + "img/havannaoak696l_detail_rsh1.09f151a6.jpg";